function validateDate(dateString) {
  //入力が空でないか未定義であることを確認します
  if (!dateString) {
    return false;
  }
  // 日付フォーマットの検証
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) {
    return false;
  }
  // 日付が有効かどうかをチェックする（1月-12月、1日-31日）
  const [year, month, day] = dateString.split("-");
  const newDate = new Date(year, month - 1, day);
  return (
    newDate.getFullYear() === Number(year) &&
    newDate.getMonth() === Number(month) - 1 &&
    newDate.getDate() === Number(day)
  );
}
export function getValidate(validateName, msg, ...params) {
  const validate = {
    //必須項目
    required: (v) => !!v || v === 0 || msg + "は必須です。",
    //必須項目
    requiredArr: (v) => (!!v && v.length !== 0) || msg + "は必須です。",
    //必須項目
    requiredBoolean: (v) => (v !== null && v !== "" && typeof v !== "undefined") || msg + "は必須です。",
    //最大文字数params[0]=maxLength
    maxlength: (v) =>
      !v || !v.length || v.length <= params[0] || msg + "は" + params[0] + "字以内で入力してください。",
    //半角数字
    number: (v) => !v || /^[0-9]+$/.test(v) || msg + "は半角数字を入力してください。",
    numberRange: (v) =>
      !v ||
      /^([0-9]|[1-9]\d{0,3}|[1-2]\d{4}|3[0-5]\d{3}|36[0-4]\d{2}|36500)$/.test(v) ||
      msg + "は0～36500の整数を入力してください。",
    numberZeroToMaxInt: (v) =>
      !v ||
      /^(0|[1-9]\d{0,8}|1\d{9}|20\d{8}|21[0-3]\d{7}|214[0-6]\d{6}|2147[0-3]\d{5}|21474[0-7]\d{4}|214748[0-2]\d{3}|2147483[0-5]\d{2}|21474836[0-3]\d|214748364[0-7])$/.test(
        v
      ) ||
      msg + "は0～2147483647の整数を入力してください。",
    //半角数字/負の整数
    numberNegative: (v) => !v || /^-?[0-9]+$/.test(v) || msg + "は半角数字を入力してください。",
    //半角数字/1以上の整数
    numberGT1: (v) => !v || /^[1-9]+[0-9]*$/.test(v) || msg + "は1以上の半角数字を入力してください。",
    // パスワードパターン
    /*passwordPatternRule: (v) =>
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) ||
      "パスワードは8文字以上の英数字が必要です。",*/
    passwordPatternRule: (v) =>
      /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*?[#?!@$%^&*-]).{8,})/.test(v) ||
      "パスワードは半角英数字記号8文字以上の入力が必要です。また、小文字、大文字、数字、記号が1文字以上含まれている必要があります。",
    //Email
    emailRule: (v) =>
      !v ||
      /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-_.])+[A-Za-z\d]{2,4}$/.test(v) ||
      "正しいメールアドレスを入力してください。",
    //url
    url: (v) =>
      !v ||
      /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i.test(
        v
      ) ||
      "正しいURLを入力してください。",
    //TEL
    phoneNumber: (v) => !v || /^([0-9]|\(|\)|-){1,25}$/.test(v) || msg + "は半角数字、(、)、-を入力してください。",
    //手数料率％
    feeRate: (v) =>
      !v ||
      /^(100(\.0{1,4})?|\d{0,2}(\.\d{1,4})?)$/.test(v) ||
      msg + "は0.0000～100.0000までの値、小数点は4桁まで入力してください。",

    //IPアドレス
    ipAddress: (v) => !v || /^[0-9a-zA-Z.:]+$/.test(v) || msg + "は半角英数字、.、:を入力してください。",
    //半角英数字
    englishAndNumberRegular: (v) => !v || /^[0-9a-zA-Z]+$/.test(v) || msg + "は半角英数字を入力してください。",
    dateFormat: (v) => !v || validateDate(v) || "正しい日付を入力してください。",
    timeFormat: (v) => !v || /^([0-1][0-9]|[2][0-3]):([0-5][0-9])$/.test(v) || "正しい時刻を入力してください。",
    dateMonthFormat: (v) => !v || /^\d{4}-(0[1-9]|1[0-2])$/.test(v) || "正しい年月を入力してください。",
    policyNo: (v) =>
      !v || /^[a-zA-Z0-9-|\uFF65-\uFF9F]+$/.test(v) || msg + "は半角英数字ｶﾅ、-を入力してください。",
    policyBranchNo: (v) =>
      !v || /^[a-zA-Z0-9|\uFF65-\uFF9F]+$/.test(v) || msg + "は半角英数字ｶﾅを入力してください。",
    searchEmail: (v) =>
      !v || /^(([0-9a-zA-Z])|-|_|\.|@)*$/.test(v) || msg + "は半角英数字記号を入力してください。",
    //半角英数字、-
    code: (v) => !v || /^[a-zA-Z0-9-]+$/.test(v) || msg + "は半角英数字、-を入力してください。",
    year: (v) => !v || /^[0-9]{4}$/.test(v) || msg + "は4桁の半角数字を入力してください。",
    //生保募集人コード(13文字の半角英数字)
    englishAndNumber13: (v) =>
      !v || /^[0-9a-zA-Z]{13}$/.test(v) || msg + "は13文字の半角英数字を入力してください。",
    max90Number: (v) => !v || /^(?:[0-9]|[1-8][0-9]|90)$/.test(v) || msg + "は0～90までの数字を入力してください。"
  };
  return validate[validateName];
}
